module.exports = __webpack_public_path__ + "static/media/GreenRay.12870de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Rays/GreenRay.png
// module id = 41
// module chunks = 0